export default "__VITE_ASSET__Cn4_m8qe__"